<template>
  <div class="item-slike">
    <div class="mb-1 slike-naslov" v-if="prikaziNaslov">
      {{ hrvatski ? 'Slike artikla' : 'Item pictures' }}
      <span class="slike-uputa">
        {{ hrvatski ? 'označi koja je zadana' : 'mark the default one' }}
      </span>
    </div>

    <v-radio-group v-model="zadana" hide-details class="mt-0 pt-0">
      <v-row no-gutters align="center" v-for="n in 7" :key="n" class="mb-1">
        <v-col cols="1">
          <v-radio :value="n" dense></v-radio>
        </v-col>
        <v-col cols="8" class="pr-1">
          <v-text-field
            :label="(hrvatski ? 'Slika ' : 'Picture ') + n"
            :value="item['ItemPicture' + n]"
            @input="upisi(n, $event)"
            :placeholder="hrvatski ? 'link ili učitana slika' : 'link or uploaded file'"
            dense
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="1" class="text-center">
          <v-btn
            icon
            small
            :loading="ucitavam === n"
            :disabled="ucitavam !== 0"
            :title="hrvatski ? 'Učitaj sliku sa računala' : 'Upload picture'"
            @click="odaberi(n)"
          >
            <v-icon small>mdi-upload</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="2" class="text-right">
          <img
            v-if="prikaz[n]"
            :src="prikaz[n]"
            class="slicica-artikl"
            alt=""
            @click="otvori(n)"
          >
          <v-icon
            v-if="!prikaz[n] && item['ItemPicture' + n]"
            small
            color="grey lighten-1"
            :title="hrvatski ? 'Slika nije dostupna' : 'Picture not available'"
          >mdi-image-off</v-icon>
        </v-col>
      </v-row>
    </v-radio-group>

    <div class="d-flex align-center">
      <v-btn small text color="primary" @click="zadana = null">
        {{ hrvatski ? 'bez zadane slike' : 'no default picture' }}
      </v-btn>
      <span v-if="poruka" class="poruka-slike">{{ poruka }}</span>
    </div>

    <input
      ref="datoteka"
      type="file"
      accept="image/*"
      style="display:none"
      @change="posalji"
    >

    <v-dialog v-model="dijalog" max-width="600px">
      <v-card>
        <v-card-text class="text-center pt-4">
          <img :src="velika" style="max-width:100%;max-height:70vh" alt="">
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dijalog = false">
            {{ hrvatski ? 'Zatvori' : 'Close' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { dohvatiSliku, posaljiSliku, zaboraviSliku } from './slikaArtikla'

export default {
  name: 'itemslike',
  props: {
    // Artikl kojem se uredjuju slike. Mijenjaju se samo polja
    // "ItemPicture1".."ItemPicture7" i "ItemDefaultPicture".
    item: {
      type: Object,
      required: true
    },
    // Kad kartica oko komponente vec ima svoj naslov, ovaj bi bio drugi po redu.
    prikaziNaslov: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      prikaz: {},
      ucitavam: 0,
      zaUpload: 0,
      poruka: '',
      dijalog: false,
      velika: ''
    }
  },
  computed: {
    hrvatski () {
      return this.$store.state.language === 'HR'
    },
    companyId () {
      return this.$store.state.companyid
    },
    // Radio usporedjuje strogo, a iz baze zadana zna doci kao tekst.
    zadana: {
      get () {
        const n = parseInt(this.item.ItemDefaultPicture, 10)
        return (n >= 1 && n <= 7) ? n : null
      },
      set (vrijednost) {
        this.$set(this.item, 'ItemDefaultPicture', vrijednost ? parseInt(vrijednost, 10) : null)
      }
    },
    // Pratimo sva polja zajedno, da se slicice osvjeze i kad se link zalijepi rucno.
    sveSlike () {
      const popis = []
      for (let n = 1; n <= 7; n++) {
        popis.push(this.item['ItemPicture' + n])
      }
      return popis.join('|')
    }
  },
  watch: {
    sveSlike: {
      immediate: true,
      handler () {
        this.osvjezi()
      }
    }
  },
  methods: {
    async osvjezi () {
      const novi = {}
      for (let n = 1; n <= 7; n++) {
        novi[n] = await dohvatiSliku(this.item['ItemPicture' + n], this.companyId)
      }
      this.prikaz = novi
    },
    odaberi (n) {
      this.zaUpload = n
      this.poruka = ''
      this.$refs.datoteka.value = ''
      this.$refs.datoteka.click()
    },
    async posalji (dogadjaj) {
      const datoteka = dogadjaj.target.files && dogadjaj.target.files[0]
      if (!datoteka) { return }
      const n = this.zaUpload
      if (!n) { return }
      if (!this.companyId) {
        this.poruka = this.hrvatski ? 'Nije odabrana firma' : 'No company selected'
        return
      }
      this.ucitavam = n
      try {
        const naziv = await posaljiSliku(datoteka, this.companyId)
        if (naziv) {
          zaboraviSliku(this.companyId, naziv)
          this.upisi(n, naziv)
          // Prva ucitana slika odmah postaje zadana, da korisnik ne mora dvaput klikati.
          if (this.zadana === null) { this.zadana = n }
          this.poruka = ''
        } else {
          this.poruka = this.hrvatski ? 'Slika nije spremljena' : 'Picture not saved'
        }
      } catch (greska) {
        const odgovor = greska.response && greska.response.data ? greska.response.data.message : ''
        this.poruka = odgovor || (this.hrvatski ? 'Greška kod slanja slike' : 'Upload error')
      }
      this.ucitavam = 0
    },
    upisi (n, vrijednost) {
      this.$set(this.item, 'ItemPicture' + n, vrijednost === null || vrijednost === undefined ? '' : vrijednost)
    },
    otvori (n) {
      if (!this.prikaz[n]) { return }
      this.velika = this.prikaz[n]
      this.dijalog = true
    }
  }
}
</script>

<style scoped>
.slike-naslov {
  font-size: 15px;
  font-weight: 700;
  color: #1565c0;
}
.slike-uputa {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  margin-left: 6px;
}
.slicica-artikl {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  cursor: zoom-in;
}
.poruka-slike {
  font-size: 12px;
  color: #c62828;
  margin-left: 8px;
}
</style>
